module.exports = __webpack_public_path__ + "static/terms-of-user-data-processing-on-the-websites-of-Bank-131-JSC-ce32416a4248ffaebd8373576b7c70cc.pdf";